import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InventoryListGoodReport  {
    _originalTypeClassName = "zERP.BO.InventoryListGoodReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InventoryListGoodReport.translate = translateService;
}
this.GoodCode = null;
this.GoodName = null;
this.UnitOfMeasurement = null;
this.Category = null;
this.RemainingUnit = null;
this.Remaining = null;
this.Price = null;
this.Value = null;
this.GroupBy = null;
this.InventoryListGoodReportKey = null;
this._key = this.InventoryListGoodReportKey = 0; 
}

static translate: TranslateService;
_key: any;
GoodCode:any;
GoodName:any;
UnitOfMeasurement:any;
Category:any;
RemainingUnit:any;
Remaining:any;
Price:any;
Value:any;
GroupBy:any;
private _InventoryListGoodReportKey:any;
get InventoryListGoodReportKey(): any {
    return this._InventoryListGoodReportKey;
  }
set InventoryListGoodReportKey(value: any) {
    this._InventoryListGoodReportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InventoryListGoodReportKey == null || $this.InventoryListGoodReportKey == 0;
            }


}